// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3uZF_","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__KWYaF","gfeWrapper":"CalendarEvent_gfeWrapper__Dhb0i"};